const QUEUE_KEY = 'ssc-log-queue';
export function encolar(entry) {
    try {
        const raw = localStorage.getItem(QUEUE_KEY);
        const queue = raw ? JSON.parse(raw) : [];
        queue.push(entry);
        if (queue.length > 100)
            queue.splice(0, queue.length - 100);
        localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
    }
    catch {
        /* storage lleno o inaccesible */
    }
}
export function drenar() {
    try {
        const raw = localStorage.getItem(QUEUE_KEY);
        if (!raw)
            return [];
        localStorage.removeItem(QUEUE_KEY);
        return JSON.parse(raw);
    }
    catch {
        return [];
    }
}
